export default async function ({ redirect, $strapi, route, $utils, error }) {
  const res = await $strapi.fetchUser()


  if (res?.role?.accesslevel) {
    //   const ress = await $strapi.findOne('accesslevels', res.role.accesslevel)
    const ress = await $strapi.graphql({
      query: `
      query {
        accesslevels(where: {
            id: "${res.role.accesslevel}"
          }) {
          route

        }
      }
    `
    })
    if (
      ress?.accesslevels?.length &&
      ress.accesslevels[0]?.route?.defaultRoutes
    ) {
      let isRoute = false
      let isDefaultRoute = true

      ress.accesslevels[0]?.route?.defaultRoutes?.some((v) => {
        if (route.path.includes(v.to)) {
          isRoute = true
          return true
        }
      })
      if (route.path.includes('account') || route.path.includes('dashboard'))
        isDefaultRoute = false

      if (!isRoute && isDefaultRoute) error({ statusCode: 404, message: '' })
    }
  }
}
